import browser from '@openclassrooms/utils/browser';
import { openPopin } from '../../Services/popin';

/**
 * @param {HTMLElement} element
 * @returns {String} selector
 */
function getPopinSelector(element) {
  let match;

  if (element.href) {
    match = element.href.match(/(#.*)/);
    if (match) {
      return match[1];
    }
  }

  return element.getAttribute('data-popin-selector');
}

// link classname -> js-popin-activator
// option: data-popin-auto="true"
// option: data-popin-selector="#popin-offer"
// option: data-popin-title="bla blah blah"
function initPopin() {
  const selector = '.js-popin-activator';

  const tryOpenPopin = (event, element) => {
    const popinSelector = getPopinSelector(element);
    const popinElement = browser.document.querySelector(popinSelector);

    if (!popinElement) {
      return;
    }

    event.preventDefault();

    openPopin(popinSelector, {
      activatorElement: element,
    });
  };

  browser.document.addEventListener(
    'click',
    (event) => {
      if (!event.target.matches(`${selector}, ${selector} *`)) {
        return;
      }

      tryOpenPopin(event, event.target.closest(selector));
    },
    { capture: true }
  );

  browser.document.addEventListener(
    'keydown',
    (event) => {
      if (!event.target.matches(`${selector}, ${selector} *`)) {
        return;
      }

      const { keyCode } = event;

      if (![13, 32].includes(keyCode)) {
        return;
      }

      tryOpenPopin(event, event.target.closest(selector));
    },
    { capture: true }
  );
}

export default {
  init: initPopin,
};
